import * as Ui from '../Ui'

const TeleExpertiseIcon = ({ teleExpertiseType }) => teleExpertiseType === 'staff'
  ? <Ui.Icon.IconMessage />
  : teleExpertiseType === 'cohort'
    ? <Ui.Icon.IconCohorte />
    : <Ui.Icon.IconExpertise />

export default TeleExpertiseIcon;
